/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connection_ReconnectingInputs */

const en_connection_reconnecting = /** @type {(inputs: Connection_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconnecting…`)
};

const ar_connection_reconnecting = /** @type {(inputs: Connection_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ إعادة الاتصال…`)
};

/**
* | output |
* | --- |
* | "Reconnecting…" |
*
* @param {Connection_ReconnectingInputs} inputs
* @param {{ locale?: "en" | "ar" }} options
* @returns {LocalizedString}
*/
export const connection_reconnecting = /** @type {((inputs?: Connection_ReconnectingInputs, options?: { locale?: "en" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connection_ReconnectingInputs, { locale?: "en" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_connection_reconnecting(inputs)
	return ar_connection_reconnecting(inputs)
});